import React from 'react'
import WidgetIcon from '../../../Atoms/WidgetIcon/WidgetIcon'
import { ReactComponent as Icon } from './LineChartWidget.Icon.svg'

const LineChartWidgetIcon = () => <WidgetIcon icon={Icon} />

export default LineChartWidgetIcon
